import { render, staticRenderFns } from "./Holiday.vue?vue&type=template&id=1cecd1c6&"
import script from "./Holiday.vue?vue&type=script&lang=js&"
export * from "./Holiday.vue?vue&type=script&lang=js&"
import style0 from "./Holiday.vue?vue&type=style&index=0&id=1cecd1c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports